export default "__VITE_ASSET__i0K$H8Iv__$_?nuxt_component=async&nuxt_component_name=IconFunctionIcons100prozentKaschmir&nuxt_component_export=default__"